import classNames from './style.module.scss';
export default classNames;
